import '../../utils/imports'

import { useTranslation } from 'react-i18next'

import BookingWidget from '../../components/BookingWidget'
import { Footer } from '../../components/Footer/Footer'
import { Header } from '../../components/Header/Header'
import { Breadcrumb } from './Breadcrumb'

export const Book = () => {
  const { t } = useTranslation()
  return (
    <>
      <Header />
      <Breadcrumb />
      <section className="contact-part pt-115 pb-115">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 className="mb-4">{t('Book your stay')}</h3>
            </div>
          </div>
          <BookingWidget />
        </div>
      </section>
      <Footer />
    </>
  )
}
